// extracted by mini-css-extract-plugin
module.exports = {"tags":"AssignTag_tags__1bU3N","tag":"AssignTag_tag__3aH26","tagDelete":"AssignTag_tagDelete__Gm_M1"};